import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Exchange} from "./exchange";
import {Free} from "./free";
import {Time} from "./time";
import {Benefit} from "./benefit";
import Money from "js-money";
import {Translate} from "../../../services/translate";

const LANGUAGES_WITHOUT_SYMBOL_CURRENCY = ['ua', 'ru'];

export const Benefits = ({ exchange }) => {
    const [exchangeRate, setExchangeRate] = useState('');

    const getSymbol = (exchangeCurrency) => {
        if (LANGUAGES_WITHOUT_SYMBOL_CURRENCY.includes(window.language)) {
            return exchangeCurrency;
        }

        const currency = Money[exchangeCurrency];

        return currency ? currency.symbol : exchangeCurrency;
    }

    useEffect(() => {
        if (!exchange) {
            return;
        }

        const baseSymbol = getSymbol(exchange.base);
        const quotedSymbol = getSymbol(exchange.quoted);
        const calculatedRate = exchange.inversion ? (1 / exchange.rate) : exchange.rate;

        setExchangeRate(`1 ${baseSymbol} = ${calculatedRate.toFixed(2)} ${quotedSymbol}`)
    }, [exchange]);

    return (
        <div className="calculator-benefits">
            <Benefit icon={<Exchange />} content={exchangeRate} showMore showMoreTarget="exchange" />
            <Benefit icon={<Free />} content={Translate('calculator_first_for_free')} />
            <Benefit icon={<Time />} content={Translate('calculator_even_in_ten_minutes')} />
        </div>
    );
};
Benefits.propTypes = {
    exchange: PropTypes.shape({
        base: PropTypes.string,
        quoted: PropTypes.string,
        rate: PropTypes.number,
        inversion: PropTypes.bool,
    }),
}